export default __webpack_public_path__ + "static/media/muymtradesmall.614baf42.png";